import { render, staticRenderFns } from "./settingsIcon.vue?vue&type=template&id=148a46b6&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148a46b6')) {
      api.createRecord('148a46b6', component.options)
    } else {
      api.rerender('148a46b6', component.options)
    }
    module.hot.accept("./settingsIcon.vue?vue&type=template&id=148a46b6&functional=true&", function () {
      api.rerender('148a46b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/listView/table/icons/settingsIcon.vue"
export default component.exports